import Home from '../modules/home/index.vue'

const Property = () => import('../modules/property/index.vue');
const Properties = () => import('../modules/properties/index.vue');
const Dashboard = () => import('../modules/dashboard/index.vue');
const DashboardProperty = () => import('../modules/dashboard-property/index.vue');
const Notifications = () => import('../modules/notifications/index.vue');
const Page404 = () => import('../modules/page-404/index.vue');

export default [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: 'Home' }
  },
  {
    path: '/property/:listing_id',
    name: 'property',
    component: Property,
    props: true,
    meta: { title: 'Property Info' }
  },
  {
    path: '/properties',
    name: 'properties',
    component: Properties,
    meta: {title: 'Properties'}
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      title: 'Dashboard',
      requiresAuth: true
    }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: Notifications,
    meta: {
      title: 'Notifications',
      requiresAuth: true
    }
  },
  {
    path: '/dashboard-property/:listing_id',
    name: 'dashboard-property',
    component: DashboardProperty,
    props: true,
    meta: {
      title: 'Property Details',
      requiresAuth: true
    }
  },
  {
    path: '/404',
    name: '404',
    component: Page404,
    meta: { title: '404 Error' }
  },
  {
    path: '*',
    redirect: '/404'
  },
];